
import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

interface CountyNearbySectionProps {
  countyName: string;
  nearbyCounties: {
    name: string;
    slug: string;
    nursing_home_count?: number;
  }[];
}

export function CountyNearbySection({ countyName, nearbyCounties }: CountyNearbySectionProps) {
  if (!nearbyCounties.length) {
    return null;
  }
  
  return (
    <div className="my-12 bg-white rounded-lg shadow-sm border border-gray-100 p-6">
      <h2 className="text-2xl font-semibold mb-4 text-grandpal-green-dark">
        Explore Nursing Homes in Counties Near {countyName}
      </h2>
      
      <p className="text-grandpal-gray mb-6">
        Looking for more options? Browse nursing homes in these nearby counties for additional choices.
      </p>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
        {nearbyCounties.map((county, index) => (
          <Link 
            key={index}
            to={`/nursing-homes/${county.slug}`}
            className="flex items-center justify-between p-4 rounded-md border border-gray-200 hover:border-grandpal-green transition-colors group"
            aria-label={`View nursing homes in ${county.name} county`}
          >
            <div>
              <h3 className="font-medium">{county.name}</h3>
              {county.nursing_home_count !== undefined && (
                <p className="text-sm text-grandpal-gray">{county.nursing_home_count} nursing homes</p>
              )}
            </div>
            <ArrowRight className="h-4 w-4 text-grandpal-green opacity-0 group-hover:opacity-100 transition-all" />
          </Link>
        ))}
      </div>
    </div>
  );
}
